angular.module('iqxCore')
.controller('ClientCurrentRequirementsUploaderCtrl', function ($scope, FormSvc, ApplicationSvc, ApiSvc, QuestionnaireSvc, $q, Upload, $timeout, $http) {

    $scope.vacancyUploader = { }
    $scope.isUploading = false
    $scope.hideUploader = true
    $scope.isEditing = true

    $scope.showDocument = function (doc) {
      var _newTab = window.open('about:blank', '_blank')
      doc.downloadError = ''
      $http.get('/api/document/doxi', { params: { id: doc.DocumentID, vacancyID: $scope.VacancyID, type: doc.SpecialType } })
        .then(function (res) {
          setTimeout(function () { // wait a second then fill that blank tab - thus stopping that pesky popup blocker!!
            _newTab.location.href = '/api/document/download?doxi=' + res.data
          }, 100)
        })
        .catch(function (err) {
          doc.downloadError = ApiSvc.ExtractError(err)
        })
    }

    $scope.toggleUploader=function(){
        $scope.hideUploader = !$scope.hideUploader
        $scope.isUploading = false
        $scope.isEditing = true
    }

      $scope.uploadCleanup=function() {
        $scope.reset()
        $scope.uploadProgress=''
        $scope.uploadError=''
        $scope.vacancyUploader={}
        $scope.tags=[]
        $scope.hideUploader=true
        $scope.isEditing = true
      }
      
      $scope.uploadFileName=function() {
        if ($scope.vacancyUploader.file) {
          return $scope.vacancyUploader.file.name
         } else {
          return 'Select file..'
         }
      }
        
      $scope.showUploadProgress=function(evt) {
        var s='Uploading...'
        if (evt && evt.total) {  // progress callback
          s=s + parseInt(100.0 * evt.loaded / evt.total) + '%'
          }
        $scope.uploadProgress=s
      }
        
      $scope.uploadExecute=function() {
        $scope.setSubmitted(true) // Ensure all validation errors appear
        if ($scope.uploadProgress || $scope.vacancyUploader.$invalid) {return}
        $scope.uploadError=''
        $scope.showUploadProgress()
        return Upload.upload({
          url:'/api/document/upload',
          file:$scope.vacancyUploader.file,
          fileFormDataName:'file',
          headers:{'X-Auth':ApplicationSvc.currentUser.token},
          fields:{'Type':$scope.vacancyUploader.Type,
                  'Description':$scope.vacancyUploader.Description,
                  'VacancyID':$scope.SiteDetails.VacancyID}
        })
        .then(function (res) {
          ApiSvc.CheckIQXResult(res.data)  // Checks the IQXResult construct and, if failed, throws exception with the message
          $scope.uploadProgress='Upload complete'
          return $timeout(function() {}, 2000)  // Display the Upload complete message for 2 seconds before refreshing and cleaning up
          }, null, $scope.showUploadProgress) // 3rd arg is the progress callback
        .then(function() {
          if ($scope.tags && $scope.tags.length) {  // Save the questionnaire
            $scope.qanswers=QuestionnaireSvc.answers($scope,{tagTarget:'tags'})
            return $scope.exec('call/NetQuestSet',{qanswers:$scope.qanswers,pLocation:'V'})
          }
          })
        .then(function() {
          if ($scope.isSwitchedOn('POPUPDOCUPDISABLE')){
            return true
          }
          return $scope.exec('call/NetMessage',{ptype:'DOCUMENTUPLOAD',
                                                ptitle:$scope.userName()+' '+$scope.vacancyUploader.Description+' Uploaded',
                                                pdescription:''
                                                })
          })
        .then(function() {
          FormSvc.alert("File Uploaded", "Your file has been uploaded\n\nA consultant may need to review the file before it is available on the web.", "success")
          return $scope.fetch()  // Refresh the list
          })
        .then(function() {
          $scope.uploadCleanup()
          })
        .catch(function (err) {
          $scope.uploadProgress=''
          FormSvc.alert("Upload Failed", (err.iqxError.text || 'Failed'), "error")
          return $q.reject($scope.uploadError=ApiSvc.ExtractError(err))
          })
        }  

      $scope.uploadFileSelected=function(file){
          $scope.vacancyUploader.file = file
      }


      $scope.doUpload=function(Description, FileType){
          if((!Description || !FileType) || (Description.length == 0 || FileType.length == 0)){
              FormSvc.alert('Invalid Fields', 'Required fields cannot be left blank', 'error')
              return false
          }

          $scope.vacancyUploader.Description = Description
          $scope.vacancyUploader.Type = FileType
          return $scope.uploadExecute()
          .then(function(){
              $scope.vacancyUploader.vacancyUploaderDescription = ""
              FileType = ""
          })
      }
})